'use client';

import { createContext, useContext } from 'react';

import { ServerInitialData } from '../provider/helpers/serverInitialDataConfigs';
import { ensureClientHost } from '@/helpers/server';

export interface IServerContext extends ServerInitialData {
  isMobileDevice: boolean;
  countryCode: string;
  hostname: string;
}

export const ServerEnvContext = createContext<IServerContext | null>(null);

export const useServer = () => {
  const context = useContext(ServerEnvContext);
  if (!context) throw new Error('ServerEnvContext is missing');
  return {
    ...context,
    hostname: ensureClientHost(context.hostname),
  };
};
